import { render, staticRenderFns } from "./ObiFileUpload.vue?vue&type=template&id=831bbcda&"
import script from "./ObiFileUpload.vue?vue&type=script&lang=js&"
export * from "./ObiFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./ObiFileUpload.vue?vue&type=style&index=0&id=831bbcda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports